/**
 * ProBadge Component
 *
 * Displays a "Pro" badge for users on the Pro subscription plan.
 * Used across profile cards, modals, and anywhere user profiles are displayed.
 */

import { Crown } from "lucide-react";

interface ProBadgeProps {
  subscriptionPlan?: string | null;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export default function ProBadge({
  subscriptionPlan,
  size = "sm",
  className = ""
}: ProBadgeProps) {
  // Only show badge for Pro subscription
  if (subscriptionPlan?.toLowerCase() !== 'pro') {
    return null;
  }

  const sizeClasses = {
    sm: "px-1.5 py-0.5 text-[10px] gap-0.5",
    md: "px-2 py-1 text-xs gap-1",
    lg: "px-2.5 py-1 text-sm gap-1"
  };

  const iconSizes = {
    sm: "w-2.5 h-2.5",
    md: "w-3 h-3",
    lg: "w-3.5 h-3.5"
  };

  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full bg-gradient-to-r from-amber-400 to-yellow-500 text-amber-900 shadow-sm ${sizeClasses[size]} ${className}`}
      title="Pro Member"
    >
      <Crown className={`${iconSizes[size]} fill-current`} />
      <span>PRO</span>
    </span>
  );
}
